export default __webpack_public_path__ + "static/media/buon4.b920d3bc.svg";